import { ValueOf } from "../type";

export const FolderSharingSettingKey = {
  FolderSharingSetting: "FOLDER_SHARING_SETTING",
} as const;

export type FolderSharingSettingKeyType = ValueOf<typeof FolderSharingSettingKey>;
